import { defineStore } from "pinia";
import axios from "axios";
import environment from "@/environment";

export const useAnalyticsStore = defineStore({
  id: "analyticsStore",
  state: () => ({
    newsBySource: [],
    newsFlow: [],
    sourcesActivity: [],
    isNewsBySourceLoading: false,
    isNewsFlowLoading: false,
    isSourcesActivityLoading: false,
    error: null,
  }),
  actions: {
    async fetchNewsBySource(params = {}) {
      this.isNewsBySourceLoading = true;
      try {
        const { data } = await axios.get(environment.getAnalyticsNewsBySource, { params });
        this.newsBySource = Object.values(data).flat();
      } catch (err) {
        this.error = err;
        console.error("Error fetching news by source:", err);
      } finally {
        this.isNewsBySourceLoading = false;
      }
    },
    async fetchNewsFlow(params = {}) {
      this.isNewsFlowLoading = true;
      try {
        const { data } = await axios.get(environment.getAnalyticsNewsFlow, { params });
        this.newsFlow = data;
      } catch (err) {
        this.error = err;
        console.error("Error fetching news flow:", err);
      } finally {
        this.isNewsFlowLoading = false;
      }
    },
    async fetchSourcesActivity(params = {}) {
      this.isSourcesActivityLoading = true;
      try {
        const { data } = await axios.get(environment.getAnalyticsSourcesActivity, { params });
        this.sourcesActivity = data;
      } catch (err) {
        this.error = err;
        console.error("Error fetching sources activity:", err);
      } finally {
        this.isSourcesActivityLoading = false;
      }
    },
  },
});
